import React from 'react';
import { Link } from 'react-router-dom';
import naascloud from '../assets/NaaSCloudsmall.png';

const MobileApp = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh' }}>

      {/* Hero */}
      <section style={{
        padding: '80px 40px 60px', textAlign: 'center',
        background: 'linear-gradient(135deg, rgba(0,5,3,0.95) 0%, rgba(8,22,40,0.9) 50%, rgba(8,145,178,0.1) 100%)'
      }}>
        <h1 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '16px' }}>
          Your Network in Your Pocket
        </h1>
        <p style={{ color: '#c4cdd8', fontSize: '1.15rem', maxWidth: '650px', margin: '0 auto 36px', lineHeight: '1.8' }}>
          Monitor, manage, and troubleshoot your entire network infrastructure from anywhere
          with the Sarvanta Mobile App for iOS and Android.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="#" className="btn-primary">App Store</a>
          <a href="#" className="btn-primary">Google Play</a>
        </div>
      </section>

      {/* Phone Mockup + Features */}
      <section style={{ padding: '60px 40px' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '40px', flexWrap: 'wrap' }}>

          {/* Phone mockup */}
          <div style={{ flex: '0 0 220px', display: 'flex', justifyContent: 'center', margin: '0 auto' }}>
            <div style={{
              width: '200px', height: '380px', borderRadius: '30px',
              border: '3px solid #1a2744', backgroundColor: '#0a1628',
              boxShadow: '0 20px 60px rgba(8,145,178,0.15)',
              position: 'relative', overflow: 'hidden'
            }}>
              {/* Notch */}
              <div style={{
                width: '80px', height: '6px', borderRadius: '3px',
                backgroundColor: '#1a2744', position: 'absolute', top: '12px',
                left: '50%', transform: 'translateX(-50%)'
              }} />
              {/* Screen content */}
              <div style={{ padding: '36px 16px 16px' }}>
                <div style={{
                  width: '50px', height: '50px', borderRadius: '12px',
                  background: 'linear-gradient(135deg, #2563eb, #0891b2)',
                  margin: '0 auto 14px', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: '1.5rem', color: '#fff', fontWeight: '700'
                }}>S</div>
                <p style={{ color: '#fff', fontSize: '0.8rem', fontWeight: '600', textAlign: 'center', marginBottom: '20px' }}>
                  Sarvanta NaaS
                </p>
                {/* Mini dashboard preview */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '12px' }}>
                  {[
                    { label: 'APs', val: '24' },
                    { label: 'Clients', val: '186' },
                    { label: 'Uptime', val: '99.9%' },
                    { label: 'Alerts', val: '0' }
                  ].map((s, i) => (
                    <div key={i} style={{
                      padding: '8px', backgroundColor: '#000503', borderRadius: '8px',
                      border: '1px solid #1a2744', textAlign: 'center'
                    }}>
                      <div style={{ color: '#22d3ee', fontSize: '0.9rem', fontWeight: '700' }}>{s.val}</div>
                      <div style={{ color: '#64748b', fontSize: '0.55rem' }}>{s.label}</div>
                    </div>
                  ))}
                </div>
                <div style={{
                  height: '40px', backgroundColor: '#000503', borderRadius: '8px',
                  border: '1px solid #1a2744', display: 'flex', alignItems: 'center',
                  padding: '0 10px'
                }}>
                  <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#22c55e', marginRight: '8px' }} />
                  <span style={{ color: '#a0aec0', fontSize: '0.55rem' }}>All systems operational</span>
                </div>
              </div>
            </div>
          </div>

          {/* Features list */}
          <div style={{ flex: '1 1 280px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '24px' }}>Full Dashboard, Mobile Experience</h2>
            {[
              { title: 'Real-Time Monitoring', desc: 'View live device health, client counts, throughput, and network status across all your locations.' },
              { title: 'Push Notifications', desc: 'Get instant alerts when devices go offline, performance degrades, or security events are detected.' },
              { title: 'Remote Troubleshooting', desc: 'Reboot access points, review logs, and diagnose connectivity issues without being on-site.' },
              { title: 'Secure Access', desc: 'Enterprise-grade authentication with the same role-based access controls as the web platform.' },
              { title: 'Offline Indicators', desc: 'Quickly see which sites or devices need attention with at-a-glance status indicators.' }
            ].map((f, i) => (
              <div key={i} style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '1.05rem', marginBottom: '4px', color: '#22d3ee' }}>{f.title}</h3>
                <p style={{ color: '#a0aec0', lineHeight: '1.6', margin: 0, fontSize: '0.92rem' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Platform integration */}
      <section style={{
        padding: '50px 40px', backgroundColor: '#0a1628',
        textAlign: 'center'
      }}>
        <h2 style={{ fontSize: '1.6rem', marginBottom: '12px' }}>Powered by the NaaS Cloud Platform</h2>
        <p style={{ color: '#a0aec0', maxWidth: '600px', margin: '0 auto 24px', lineHeight: '1.7' }}>
          The mobile app connects directly to the same NaaS Cloud platform you use on desktop.
          All your data, configurations, and analytics — synced in real time.
        </p>
        <Link to="/naascloud" className="btn-outline" style={{ padding: '12px 28px' }}>
          Explore NaaS Cloud
        </Link>
      </section>

      {/* Download CTA */}
      <section style={{ padding: '60px 40px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>Download the App</h2>
        <p style={{ color: '#a0aec0', marginBottom: '28px' }}>
          Available for iOS and Android. Free for all Sarvanta NaaS Cloud customers.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="#" className="btn-primary">App Store</a>
          <a href="#" className="btn-primary">Google Play</a>
        </div>
      </section>
    </div>
  );
};

export default MobileApp;
